import styled from "styled-components";
import { Button } from "antd";

export const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const AuditLogButton = styled(Button)`
  position: relative;
  bottom: 4px;
`;
